var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agent-home"},[_c('mainNav'),_c('div',{staticClass:"agent-body"},[_c('transition',{attrs:{"name":"el-fade-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }